import { render, staticRenderFns } from "./new-registro-user.vue?vue&type=template&id=566da962&scoped=true&"
import script from "./new-registro-user.vue?vue&type=script&lang=js&"
export * from "./new-registro-user.vue?vue&type=script&lang=js&"
import style0 from "./new-registro-user.vue?vue&type=style&index=0&id=566da962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566da962",
  null
  
)

export default component.exports